module.exports = __webpack_public_path__ + "img/mask_new.448daf14.png";